import React from 'react';
import {Navigate, useRoutes} from 'react-router-dom';
import {publicRoutes} from './Public';
import {mainRoutes} from './Main';

export default function Router() {
  return useRoutes([

    // Routes de l'app Public
    ...publicRoutes,

    // Main routes
    ...mainRoutes,

    {path: '*', element: <Navigate to="/404" replace />},
  ]);
}
